import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import { CustomerManageParams, CustomerManageListResult } from '@/typings/api/customer'
/**
 *----------------客户管理---------------
 */
// 获取客户管理列表数据
export function customerList(data: CustomerManageParams) {
  return request.post<CustomerManageListResult, CustomerManageListResult>('/zbu/api/customerCenter/getList', data)
}
// 查询集团客户脱敏详情
export function getListBySensitize(params: any) {
  return request.get<AxiosResult, AxiosResult>('/zbu/api/customerCenter/getListBySensitize', { params })
}
/**
 *----------------客户明细---------------
 */
/**
 *客户明细列表
 */
export function customerAggregationList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/customerCenter/getItems', data)
}
/**
 *客户合并
 */
export function customerMerge(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/customerCenter/merge', data)
}
/**
 *客户解除绑定
 */
export function customerUnmerge(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/customerCenter/unmerge', data)
}
/**
 *查询客户明细脱敏详情
 */
export function getItemsBySensitize(params: any) {
  return request.get<AxiosResult, AxiosResult>('/zbu/api/customerCenter/getItemsBySensitize', { params })
}
